import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "row gx-0 p-4 px-lg-5" }
const _hoisted_2 = {
  key: 0,
  class: "text-muted d-flex min-vh-80 justify-content-center align-items-center flex-column"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h5", null, "OCURRIÓ UN ERROR", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h6", null, "No pudimos obtener la información solicitada", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h6", null, "Seleccioná otra opción para resolver el problema", -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "col-12"
}
const _hoisted_8 = {
  key: 2,
  class: "col-12"
}
const _hoisted_9 = { class: "d-flex justify-content-between flex-xl-row flex-column align-items-start" }
const _hoisted_10 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_11 = { class: "text-uppercase fw-bold mb-0" }
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 0,
  class: "d-flex align-items-center location-link"
}
const _hoisted_14 = ["href"]
const _hoisted_15 = {
  key: 0,
  class: "d-block d-md-none w-100 text-center my-4"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("strong", null, "→", -1)

import { onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { useRoute, useRouter } from 'vue-router'
import { key } from '@/setup/store'
import { VuexStore } from '@/interfaces/VuexStore'
import { CardInterface } from '@/interfaces/CardInterface'
import useNavigationComplete from '@/composables/useNavigationComplete'
import LoadingSkeletonDetail from '@/skeletor/LoadingSkeletonDetail.vue'
import { activityService } from '@/services/activity.service'
import { locationService } from '@/services/location.service'
import AppContentButtonsComponent from '@/components/AppContentButtonsComponent.vue'
import AppSelectCard from '@/components/AppSelectCard.vue'
import DetailSeccion from '@/views/detail/DetailSeccion.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentUbicaciones',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const { navigation } = useNavigationComplete()
const { state, getters, commit } = useStore<VuexStore>(key)
const { t } = useI18n()
const loading = ref<boolean>(true)
const data = ref()
const URLgoogleMaps = ref('')
const error = ref(false)
const totalCard = ref(0)

const ready = (total: any) => {
  totalCard.value = total
}

const resolveRequest = async (idRoute: number) => {
  try {
    URLgoogleMaps.value = ''
    loading.value = true
    error.value = false

    const dataLocation = await locationService.ver(idRoute)
    data.value = dataLocation
    if (dataLocation.linkMapa) {
      URLgoogleMaps.value = dataLocation.linkMapa
    }
  } catch (e) {
    error.value = true
  } finally {
    loading.value = false
  }
}

onMounted(async () => {
  await resolveRequest(parseInt(route.params.id.toString()))
})

watch(
  () => route.params?.id,
  async (idRoute) => {
    if (!idRoute) {
      return
    }
    await resolveRequest(parseInt(idRoute.toString()))
  }
)

const completeSelection = (data: CardInterface) => {
  commit('COMPLETE_ACTIVIDAD', data)
  router.push({
    name: 'DetailUbicaciones',
    params: { id: route.params.id, actividadId: data.id }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (error.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_6))
      : (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createVNode(LoadingSkeletonDetail)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", null, [
                (!_unref(state).evento?.fidelizacion)
                  ? (_openBlock(), _createElementBlock("h6", _hoisted_10, _toDisplayString(_unref(t)('titles.ubicacion.Stitle2')), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("h2", _hoisted_11, _toDisplayString(_unref(navigation).ubicacion?.title), 1),
                _createElementVNode("h6", {
                  class: "text-uppercase",
                  innerHTML: _unref(navigation).ubicacion?.subtitle
                }, null, 8, _hoisted_12)
              ]),
              (URLgoogleMaps.value && !_unref(state).evento?.fidelizacion)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    _createVNode(_component_Icon, {
                      class: "icono icono-location",
                      icon: ['fas', 'map-marker-alt']
                    }),
                    _createElementVNode("a", {
                      href: URLgoogleMaps.value,
                      target: "_blank",
                      class: "nav-link fw-bold"
                    }, " Ver ubicacion", 8, _hoisted_14)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(AppSelectCard, {
              service: _unref(activityService),
              class: "select d-flex flex-nowrap flex-lg-wrap overflow-auto justify-content-start",
              "primary-navigation": false,
              onReady: ready,
              onCallback: completeSelection,
              "list-id": parseInt(_unref(route).params?.id.toString()),
              preselect: _unref(route).params?.actividadId
            }, null, 8, ["service", "list-id", "preselect"]),
            (totalCard.value > 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createTextVNode(" Deslizá "),
                  _hoisted_16,
                  _createTextVNode(" para ver todas nuestras actividades ")
                ]))
              : _createCommentVNode("", true),
            _createVNode(AppContentButtonsComponent, {
              "disabled-return": false,
              disabledContinue: !_unref(getters).actualActividadURL.hasOwnProperty('name'),
              urlRedirect: _unref(getters).actualActividadURL,
              goBack: { name: 'Home' }
            }, null, 8, ["disabledContinue", "urlRedirect"]),
            _createVNode(DetailSeccion, {
              title: data.value.nombre,
              "sub-title": data.value.subtitulo,
              imgs: data.value.slider,
              html: data.value.descripcion,
              "only-info": Boolean(_unref(state).evento?.fidelizacion)
            }, null, 8, ["title", "sub-title", "imgs", "html", "only-info"])
          ]))
  ]))
}
}

})